import React from "react";

const Start = ({ section }) => {
  return (
    <>
      {section === 0 && (
        <>
          <h1>GRAND OPENING</h1>
          <h2> WINE AND DINE </h2>
          <h2>WITH US!</h2>
        </>
      )}
    </>
  );
};

export default Start;
